import { mixpanel, safeWindowOpen } from '@/core';

const getFreeTrialLink =
  'https://www.ringcentral.com/office/plansandpricing.html?BMID=APPGALLERYTRIALS';

export const onGetFreeTrial = (pageName, actionName) => {
  safeWindowOpen(getFreeTrialLink);
  mixpanel.trackAction(pageName, actionName);
};
